import React, { useState, useEffect, useRef } from 'react';

export default function InputModal({ isOpen, title, initialValue, onClose, onConfirm }) {
    const [value, setValue] = useState(initialValue || '');
    const inputRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            setValue(initialValue || '');
            // Slight timeout to ensure render before focus
            setTimeout(() => inputRef.current?.focus(), 50);
        }
    }, [isOpen, initialValue]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
            <div className="bg-gray-800 border border-gray-600 rounded-lg p-6 shadow-2xl w-96 transform scale-100 transition-transform">
                <h3 className="text-lg font-bold text-white mb-4">{title}</h3>

                <input
                    ref={inputRef}
                    type="text"
                    className="w-full bg-gray-900 border border-gray-700 rounded px-3 py-2 text-white mb-6 focus:border-blue-500 outline-none"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') onConfirm(value);
                        if (e.key === 'Escape') onClose();
                    }}
                />

                <div className="flex justify-end gap-3">
                    <button
                        className="px-4 py-2 text-gray-300 hover:text-white text-sm"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded text-sm font-bold"
                        onClick={() => onConfirm(value)}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
}
